import React from 'react'

// Illustration for the "Contained" row style.
// The background, border and shadow are applied to the row itself, so every
// column shares one panel. We draw a single box with both columns inside it.
export default function IconContainerStyleContained({ ...rest }) {
    return (
        <svg width='56' height='36' viewBox='0 0 56 36' fill='none' xmlns='http://www.w3.org/2000/svg' {...rest}>
            {/* the one shared panel */}
            <rect x='0.5' y='0.5' width='55' height='35' rx='4' fill='#EEEEED' stroke='#E1E1E0' />
            {/* left column content */}
            <rect x='6' y='12' width='20' height='3' rx='1.5' fill='#C4C4C1' />
            <rect x='6' y='18' width='20' height='2' rx='1' fill='#D6D6D4' />
            <rect x='6' y='22' width='14' height='2' rx='1' fill='#D6D6D4' />
            {/* right column content */}
            <rect x='30' y='12' width='20' height='3' rx='1.5' fill='#C4C4C1' />
            <rect x='30' y='18' width='20' height='2' rx='1' fill='#D6D6D4' />
            <rect x='30' y='22' width='14' height='2' rx='1' fill='#D6D6D4' />
        </svg>
    )
}
